
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_43611","data-name":"Group 43611","xmlns":"http://www.w3.org/2000/svg","width":"3","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-proj-menu"}},[_c('rect',{attrs:{"id":"Rectangle_14447","data-name":"Rectangle 14447","width":"3","height":"13","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_43610","data-name":"Group 43610","clip-path":"url(#clip-path-proj-menu)","fill":"#4f5c71"}},[_c('path',{attrs:{"id":"Path_29931","data-name":"Path 29931","d":"M3 1.5A1.5 1.5 0 111.5 0 1.5 1.5 0 013 1.5"}}),_c('path',{attrs:{"id":"Path_29932","data-name":"Path 29932","d":"M3 6.5A1.5 1.5 0 111.5 5 1.5 1.5 0 013 6.5"}}),_c('path',{attrs:{"id":"Path_29933","data-name":"Path 29933","d":"M3 11.5A1.5 1.5 0 111.5 10 1.5 1.5 0 013 11.5"}})])])
          )
        }
      }
    